// Magyar szövegek — a vendéget végig magázzuk.
// A magyarban a számnév után a főnév egyes számban áll („2 éjszaka”), ezért az
// üzeneteknek nincs külön többes alakjuk: mindegyik egyetlen tagból áll.
export default {
    general: {
        back:     'Vissza',
        next:     'Tovább',
        cancel:   'Mégse',
        from:     'már',
        night:    'éjszakánként',
        nights:   '{count} éjszaka',
        loading:  'Betöltés …',
        language: 'Nyelv',
        theme:    'Megjelenés',
    },
    errors: {
        generic_error: 'Hiba történt. Kérjük, próbálja meg újra.',
        invalid_data:  'A megadott adatok nem megfelelőek.',
        not_found:     'Nem található.',
        offline:       'Nem érjük el a szállodát. Ellenőrizze az internetkapcsolatot, és próbálja meg újra.',
        no_house:      'Ez a szálláshely jelenleg nem fogad online foglalást.',
        taken:         'Ezt a szobát időközben más lefoglalta. Kérjük, válasszon másik szobát vagy másik időpontot.',
        too_many:      'Túl sok próbálkozás. Kérjük, várjon egy pillanatot, és próbálja meg újra.',
        too_many_guests: 'Ebben a szobában nincs hely ennyi vendégnek.',
        booking_failed:  'A foglalást nem sikerült rögzíteni.',
        offer_gone:      'Az ajánlat már nem érvényes. A szálláshely szokásos árait mutatjuk.',
    },
    step: {
        dates:   'Időpont',
        rooms:   'Szoba',
        guest:   'Adatok',
        summary: 'Összegzés',
        done:    'Megerősítve',
    },
    search: {
        title:          'Foglaljon szobát',
        lead:           'Válassza ki az időpontot és a vendégek számát; megmutatjuk a szabad szobákat és az árat.',
        arrival:        'Érkezés',
        departure:      'Távozás',
        adults:         'Felnőttek',
        children:       'Gyermekek',
        submit:         'Szabad szobák keresése',
        stay_too_long:  'A tartózkodás legfeljebb {nights} éjszaka lehet.',
        departure_after: 'A távozásnak az érkezés utánra kell esnie.',
        arrival_past:   'Az érkezés nem eshet a múltba.',
    },
    package: {
        title: 'A csomagban',
        included: 'benne van',
        surcharges_total: 'Felárak',
        kind_room_service: 'Szobaszerviz',
        kind_dining: 'Étkezés',
        kind_facility: 'Szolgáltatás',
        kind_parking: 'Parkolás',
        kind_service: 'Szolgáltatás',
        kind_product: 'Termék',
        when_arrival: 'érkezéskor',
        when_each_night: 'minden éjjel',
        when_departure: 'távozáskor',
    },
    rooms: {
        component_gone: 'A csomag egy része nem elérhető ezekre a napokra',
        component_gone_hint: 'Betelt: {what}. Próbáljon meg más dátumot — a csomag maga továbbra is érvényes.',
        title:      'Szabad szobák',
        stay:       '{arrival} – {departure} · {nights} · {guests}',
        none:       'A választott időpontra nincs szabad szoba.',
        none_hint:  'Próbálja meg másik időponttal vagy kevesebb vendéggel.',
        change:     'Időpont módosítása',
        choose:     'Kiválasztom',
        per_stay:   'a teljes tartózkodásra',
        left:       'Már csak {count} szoba szabad',
        sleeps:     'Legfeljebb {count} fő',
        beds:       '{count} ágy',
        photo_of:   'A(z) {name} szoba fényképe',
        offer_price: 'ajánlati ár (−{percent}%)',
        early_booking:       'Előfoglalás −{percent}%',
        early_booking_saved: 'megtakarítás: {amount}',
        offer_applied: 'Az alábbi árak ehhez az ajánlathoz tartoznak, {percent}%-kal csökkentve.',
        offer_gone: 'Az ajánlat már nem érvényes',
        offer_gone_hint: 'A szálláshely visszavonta vagy módosította, ezért alább a szokásos árak láthatók.',
    },
    board: {
        none:       'Csak szállás',
        breakfast:  'Szállás reggelivel',
        half_board: 'Félpanzió',
        full_board: 'Teljes panzió',
        all_inclusive: 'All inclusive',
    },
    guest: {
        title:      'Az Ön adatai',
        lead:       'A foglalást erre az e-mail-címre igazoljuk vissza.',
        first_name: 'Keresztnév',
        last_name:  'Vezetéknév',
        email:      'E-mail-cím',
        phone:      'Telefon',
        notes:      'Üzenet a szállodának',
        notes_hint: 'Nem kötelező — például az érkezés időpontja vagy egy különleges kérés.',
        required:   'Ennek a mezőnek a kitöltése kötelező.',
        email_bad:  'Adjon meg érvényes e-mail-címet.',
        submit:     'Tovább az összegzéshez',
    },
    summary: {
        room_only: 'Szállás',
        payment_optional: 'Fizethet most bankkártyával, vagy érkezéskor a recepción.',
        payment_deposit: 'A foglalást {amount} előleg (a végösszeg {percent} %-a) erősíti meg — most vagy az e-mailben küldött hivatkozáson keresztül. A fennmaradó összeget érkezéskor, a recepción rendezi.',
        payment_full: 'A foglalást a teljes összeg, {amount} erősíti meg — most vagy az e-mailben küldött hivatkozáson keresztül.',
        title:     'Összegzés',
        lead:      'Ellenőrizze az adatokat, és erősítse meg a foglalást.',
        stay:      'Tartózkodás',
        room:      'Szoba',
        offer:     'Ajánlat',
        early_booking: 'Előfoglalás',
        guests:    'Vendégek',
        contact:   'Kapcsolat',
        city_tax:  'Idegenforgalmi adó {amount} személyenként és vendégéjszakánként',
        total:     'Mindösszesen áfával',
        payment:   'Fizetés érkezéskor, a recepción.',
        cancellation: 'Ingyenes lemondás eddig: {date}',
        terms:     'Általános szerződési feltételek',
        accept:    'Elfogadom a foglalási és lemondási feltételeket.',
        accept_required: 'A foglaláshoz el kell fogadnia a feltételeket.',
        submit:    'Foglalás megerősítése',
        sending:   'Küldés …',
    },
    done: {
        payment_optional: 'Fizethet most bankkártyával, vagy érkezéskor a recepción.',
        payment_remainder: 'A fennmaradó {amount} összeget érkezéskor, a recepción rendezi.',
        payment_required: 'A tartózkodás véglegesítéséhez fizessen {amount} összeget',
        payment_required_hint: 'A szoba le van foglalva, és várja Önt. Az összeget kifizetheti most, vagy később, a visszaigazoló e-mailben található hivatkozással.',
        payment_done: 'A fizetést megkaptuk. Köszönjük!',
        pay_now: '{amount} fizetése',
        pay_later: 'A fizetési hivatkozás a visszaigazoló e-mailben is megtalálható.',
        pay_failed: 'A fizetési oldalt nem sikerült megnyitni. Próbálja meg újra, vagy használja az e-mailben található hivatkozást.',
        title:      'Foglalását megerősítettük',
        number:     'Foglalási szám',
        keep:       'Őrizze meg a foglalási számot — ez alapján találjuk meg Önt, ha telefonál.',
        mail_sent:  'A visszaigazolást elküldtük a következő címre: {email}.',
        mail_none:  'A visszaigazolást nem tudtuk e-mailben elküldeni; a szálloda fel fogja keresni Önt.',
        payment:    'Fizetés érkezéskor, a recepción.',
        again:      'Új foglalás',
    },
    occupancy: {
        adults:   '{count} felnőtt',
        children: '{count} gyermek',
    },
    license: {
        title: 'Ez a szolgáltatás nincs bekapcsolva',
        lead: 'Ez a szálloda nem kapcsolta be az online foglalást, ezért ezen az oldalon nem lehet szobát foglalni.',
        contact: 'Hívja a szálloda recepcióját — szívesen elkészítik Önnek a foglalást.',
    },
    closed: {
        title: 'A foglalás jelenleg nem lehetséges',
        lead:  'Ez a szálláshely jelenleg nem értékesít szobát az interneten. Kérjük, hívja a recepciót — készséggel segítenek.',
    },
}
